export const FormaFarmaceuticaMatch: { [key: string]: number } = {
  'Não informado': 0,
  'Adesivo Transdérmico': 1,
  'Aerosol Oral': 2,
  Cápsula: 3,
  'Cápsula de Liberação Prolongada': 3,
  'Cápsula de Liberação Retardada': 3,
  'Cápsula Mole': 3,
  'Cápsula para Inalação Oral': 3,
  Comprimido: 4,
  'Comprimido de Liberação Prolongada': 4,
  'Comprimido de Liberação Retardada': 4,
  'Comprimido Dispersível': 4,
  'Comprimido Mastigável': 4,
  'Comprimido Orodispersível': 4,
  'Comprimido para Suspensão': 4,
  'Comprimido para Uso Tópico': 4,
  'Comprimido Revestido de Liberação Prolongada': 4,
  'Comprimido Solúvel': 4,
  'Comprimido Sublingual': 4,
  Creme: 5,
  'Creme Vaginal': 5,
  Elixir: 6,
  'Emulsão Oral': 7,
  'Enema Retal': 8,
  Gel: 9,
  'Goma de Mascar': 10,
  'Granulado Oral': 11,
  'Implante Subcutâneo': 12,
  Loção: 13,
  'Óleo para Uso Oral': 14,
  'Óvulo Vaginal': 15,
  Pasta: 16,
  Pastilha: 17,
  Pó: 18,
  'Pó para Dispersão Oral': 18,
  'Pó para Inalação Oral': 18,
  'Pó para Solução Injetável': 18,
  'Pó para Solução Oral': 18,
  'Pó para Suspensão Injetável': 18,
  'Pó para Suspensão Oral': 18,
  Pomada: 19,
  'Pomada Oftálmica': 19,
  'Seringa Preenchida': 20,
  Solução: 21,
  'Solução Aerossol': 21,
  'Solução Capilar': 21,
  'Solução Injetável': 21,
  'Solução Injetável com sistema de Aplicação': 21,
  'Solução Injetável Intratecal ou Intrabronquica': 21,
  'Solução Nasal': 21,
  'Solução Oftálmica': 21,
  'Solução Oral': 21,
  'Solução Otológica': 21,
  'Solução para Inalação': 21,
  'Solução para Infusão': 21,
  'Solução para Nebulização': 21,
  'Solução para Uso Tópico': 21,
  'Solução Retal': 21,
  'Solução Spray': 21,
  'Solução Tópica': 21,
  'Supositório Retal': 22,
  'Suspensão Injetável': 23,
  'Suspensão Injetável Intratecal ou Intrabronquica': 23,
  'Suspensão Oftálmica': 23,
  'Suspensão Oral': 23,
  'Suspensão para Inalação Nasal': 23,
  Tintura: 24,
  Unidade: 25,
  Xampu: 26,
  Xarope: 27,
};
